import { useEffect, useState } from 'react';
import './lsc.scss';
import { convertMoneyTxt, getDateTimeDD_MM_YYYY, getDateTimeHH_MM_SS } from 'utils/time-utils';
import txcbApi from 'apis/txcb-api';

interface Props {
  onClose: () => void;
}

interface listHisMini {
  taixiuId: string;
  typed: number;
  result: (number | string)[];
  txtBet: string;
  betamount: string;
  refundamount: string;
  winamount: string;
  time: string;
  date: string;
}

export default function LSCMiniGame(props: Props) {
  const { onClose } = props;

  const [listHis, setListHis] = useState<listHisMini[]>([]);
  const [pagiNum, setPagiNum] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    getHistoryMyBet(1);
  }, []);

  const getHistoryMyBet = async (page: number) => {
    const param = {
      page,
      size: 9,
      sort: 'id,desc',
    };
    try {
      const { data } = await txcbApi.getHistoryMyBet(param);
      if (data.message === 'success') {
        setListHis(convertData(data.content));
        setTotalPages(data.totalPages ?? 0);
        setPagiNum(page);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const convertData = (data: any): listHisMini[] => {
    if (!data) return [];

    return data.map((item: any) => {
      const betamount = convertMoneyTxt(item.betamount);
      const refundamount = convertMoneyTxt(item.refundamount);
      const winamount = convertMoneyTxt(item.winamount);

      let resultArr: (number | string)[] = ['x', 'x', 'x'];
      let txtBet = '';

      if (item.result && item.result !== '0') {
        const arr = String(item.result).split('').map(Number);
        if (arr.length === 3) {
          resultArr = arr;
          txtBet = arr.reduce((a, b) => a + b, 0) > 10 ? 'Tài' : 'Xỉu';
        }
      }

      const betTime = item.bettime
        ? new Date(String(item.bettime).replace(/-/g, '/'))
        : new Date();

      const time = getDateTimeHH_MM_SS(betTime);
      const date = getDateTimeDD_MM_YYYY(betTime);

      return {
        taixiuId: String(item.taixiuId ?? ''),
        typed: Number(item.typed ?? 0),
        result: resultArr,
        txtBet,
        betamount,
        refundamount,
        winamount,
        time,
        date,
      };
    });
  };

  const pagiHis = (flag: 'prev' | 'next') => {
    if (flag === 'prev' && pagiNum > 1) {
      getHistoryMyBet(pagiNum - 1);
    } else if (flag === 'next' && pagiNum < totalPages) {
      getHistoryMyBet(pagiNum + 1);
    }
  };

  return (
    <div className="wrapbxh">
      <div id="lsc">
        <section className="lsp-txcb">
          <div className="wrapper">
            <div className="title">LỊCH SỬ CƯỢC</div>
            <div className="close" onClick={onClose}>
              <img src={require('assets/images/txcanban/statis/close.png')} alt="" />
            </div>
            <div className="inner">
              <div className="pagi">
                <button
                  className="btnPagi btnPagiPrev"
                  disabled={pagiNum <= 1}
                  onClick={() => pagiHis('prev')}
                >
                  <img src={require('assets/images/txcanban/statis/prev.png')} alt="prev" />
                </button>
                <span>{pagiNum}</span>
                <button
                  className="btnPagi btnPagiNext"
                  disabled={pagiNum >= totalPages}
                  onClick={() => pagiHis('next')}
                >
                  <img src={require('assets/images/txcanban/statis/next.png')} alt="next" />
                </button>
                <p className="total-page">Total: {totalPages}</p>
              </div>
              <div className="tblScorllHorizontal">
                <div className="innerTblScroll">
                  <table>
                    <thead>
                      <tr>
                        <th>Phiên</th>
                        <th>Đặt</th>
                        <th>Kết Quả</th>
                        <th>Cược</th>
                        <th>Hoàn Trả</th>
                        <th>Thắng</th>
                        <th>Thời Gian</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listHis.length === 0 ? (
                        <tr>
                          <td colSpan={7}>Không có dữ liệu</td>
                        </tr>
                      ) : (
                        listHis.map((item, idx) => (
                          <tr key={`${item.taixiuId}-${idx}`}>
                            <td>{item.taixiuId}</td>
                            <td>{item.typed === 1 ? 'Tài' : 'Xỉu'}</td>
                            <td>
                              {item.result[0]}-{item.result[1]}-{item.result[2]}
                              <p>({item.txtBet})</p>
                            </td>
                            <td className="moneyB">{item.betamount}</td>
                            <td className="moneyR">{item.refundamount}</td>
                            <td className="moneyW">{item.winamount}</td>
                            <td>
                              {item.time}
                              <p>{item.date}</p>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
